module.exports = __webpack_public_path__ + "img/chart-mobile.62a1b9bd.png";